<div *ngIf="!readyToChat" class="message-panel__status">{{stateMessage}}</div>
<div class="message-panel__container">
  <message-contact-list class="message-panel__side" (contactSelected)="openChatWith($event)" (roomSelected)="openRoom($event)" (callTo)="callToContactSelected($event)"></message-contact-list>
  <div class="message-panel__body" [ngClass]="{'open': chatOpen}">
    <div *ngIf="!contact && !roomName" class="message-panel__welcome text-primary">
      <div style="font-size: 151px;"><i class="fa fa-comments" aria-hidden="true"></i>
      </div>
      <div>Chào mừng đến với <b>Calista!</b></div>
    </div>
    <message-chat *ngIf="contact"
                  [username]="contact.usercode"
                  [audioCall]="audioCall"
                  [videoCall]="videoCall"
                  [closable]="closable"
                  (onAudioCall)="openAudioCall($event)"
                  (onVideoCall)="openVideoCall($event)"
                  (onClose)="closeChat()"></message-chat>
    <room-chat *ngIf="roomName" [roomName]="roomName"></room-chat>
  </div>
</div>
